export const enDeals = {
  OpenAuction: 'Open Auction',
  PrivateAuction: 'Private Auction',
  ProgrammaticGuaranteed: 'Programmatic Guaranteed',
  PreferredDeal: 'Preferred Deal',
  SeatID: 'Seat ID',
  DealTierTooltip: 'Programmatic Guaranteed deals are required to have the highest priority to ensure delivery.',
};